import React from 'react'
// import { MenuItemType } from '@next-nx/utils/types'
import { useTrans } from '@next-nx/hooks'
import { getIcon } from '@next-nx/utils/icons'
import { IconBg } from '@next-nx/shared-ui/atoms'
import styles from './CategoriaCard.module.sass'
import Link from 'next/link'
import { getAnchorRel } from '@next-nx/utils'

interface Props {
  iconStyleName?: string
  itemText?: string
  itemUrl?: string
  variant?: '' | 'soluzione'
  animationVariant?: 'se' | 'nw'
  onClick?: () => void
  className?: string
  sezione?: string
  interazioneName?: string
  handleTracking?: (s: string, c: string, t?: string) => void
}

const CategoriaCard = (props: Props) => {
  const {
    iconStyleName = '',
    itemText = '',
    itemUrl = '',
    variant = '',
    animationVariant = 'se',
    onClick = undefined,
    className = '',
    sezione = '',
    interazioneName = '',
    handleTracking = () => undefined,
  } = props

  const t = useTrans()

  const handleClick = () => {
    interazioneName === 'faq'
      ? handleTracking('argomento', itemUrl?.split('faq/')[1], itemText)
      : handleTracking(sezione, itemText)
  }

  const content = itemText ? (
    <>
      {iconStyleName && animationVariant && (
        <IconBg
          icon={getIcon(iconStyleName)}
          animationVariant={animationVariant}
          className={styles.icon}
          bgClassName={styles.iconBg}
        />
      )}
      <span className={styles.content}>
        {variant === 'soluzione' && <span className={styles.intro}>{t('Soluzioni per')}</span>}
        <span className={styles.title}>{itemText}</span>
      </span>
    </>
  ) : (
    <></>
  )

  return itemUrl && itemText ? (
    onClick ? (
      <button
        role="button"
        className={`${styles.root} ${variant ? styles[`root--${variant}`] : ''} ${
          !!onClick ? styles['root--clickable'] : ''
        } ${className}`}
        onClick={() => {
          onClick()
          handleClick()
        }}
      >
        {content}
      </button>
    ) : (
      <Link href={itemUrl || ''}>
        <a
          className={`${styles.root} ${className}`}
          rel={getAnchorRel(itemUrl || '')}
          onClick={handleClick}
        >
          {content}
        </a>
      </Link>
    )
  ) : (
    <></>
  )
}

export default CategoriaCard
